interface ErrorKind {
  [key: number | string]: {
    title: string
    message: string
  }
}

type ErrorMessageType = {
  [key: string]: ErrorKind
}

export interface ErrorResponse {
  errors: ValidationError[]
}

export interface ValidationError {
  message: string
  location?: string
}

export const errorMessages: ErrorMessageType = {
  room: {
    404: {
      title: 'Room not found',
      message: 'The room you are looking for might have been removed or temporarily unavailable',
    },
  },
  default: {
    404: {
      title: 'Page not found',
      message: 'The page you are looking for might have been removed or temporarily unavailable',
    },
  },
}

export const resolveErrorMessageByTypeAndStatus = (type: string, status: keyof ErrorKind) => {
  const [thunkType, actionType] = type.split('/')
  return errorMessages[thunkType] ? errorMessages[thunkType][status] : errorMessages['default'][status]
}

export const NO_PAYMENT_METHOD_FOUND = /No payment method found/
export const ENTERPRISE_AGGREGATE_INVOICE = /Enterprise aggregate invoice/
export const EXTERNAL_USER_ALREADY_EXISTS = /User with location.+already exists/

export const INVALID_WEALTHBOX_INTEGRATION = /Invalid wealthbox integration/
export const INVALID_REFRESH_TOKEN_INTEGRATION = /Could not get access token with refresh token/
